import styled from 'styled-components'
import { themeStyles } from '../../../styles/theme'

export const StyledFooterElement = styled.footer`
  background-color: ${themeStyles.colors.black.main};
  color: ${themeStyles.colors.white.main};
`
